import styled from '@emotion/styled';
import { mediaMax, mediaMin, breakpoints, COLORS } from 'styles';
import BaseButton from 'components/ui/buttons/Button';
import { css } from '@emotion/react';

type FooterProps = {
  noBGImage?: boolean;
  defaultFooter?: boolean;
  liteFooter?: boolean;
  inmobiFooter?: boolean;
};

export const FooterMenuTitle = styled.span`
  margin-bottom: 16px;
  font-weight: var(--qr-global-font-weight-bold);
  font-size: var(--qr-global-font-size-default);
  color: var(--qr-global-color-blue);
`;

export const FooterWrapper = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--qr-global-color-white);
  width: 100%;
  margin-top: 20px;
  padding: 20px;
  padding-bottom: ${({ defaultFooter }) => defaultFooter && 0};
  padding-bottom: ${({ liteFooter }) => liteFooter && 0};
  margin-top: ${({ liteFooter }) => liteFooter && 0};

  ${mediaMax(breakpoints.mobileS)} {
    width: 100%;
    padding: 0 10px;
  }

  ${mediaMin(breakpoints.tabletM)} {
    margin-top: ${({ noBGImage }: FooterProps) => (noBGImage ? '57px;' : '60px;')};
    padding: 0px;
    padding-bottom: 55px;
    align-items: center;
    flex-flow: row;
    flex: 0;
    justify-content: flex-start;
    padding-bottom: ${({ defaultFooter }) => defaultFooter && 0};
    margin-top: ${({ liteFooter }) => liteFooter && 0};
    padding-bottom: ${({ liteFooter }) => liteFooter && 0};
  }

  ${mediaMin(breakpoints.laptopS)} {
    margin-top: ${({ noBGImage }: FooterProps) => (noBGImage ? '57px;' : '')};
    padding-bottom: 55px;
    align-items: center;
    flex-flow: row;
    flex: 0;
    justify-content: left;
    padding-bottom: ${({ defaultFooter }) => defaultFooter && 0};
    margin-top: ${({ liteFooter }) => liteFooter && 0};
    padding-bottom: ${({ liteFooter }) => liteFooter && 0};
  }
`;

export const FooterInner = styled.div`
  ${mediaMin(breakpoints.tabletM)} {
    width: 100%;
  }
`;

export const DefFooterBottom = styled.div`
  padding: 35px 0;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 25px;

  ${mediaMin(breakpoints.tabletM)} {
    flex-direction: row;
  }

  ${mediaMin(breakpoints.laptopS)} {
    border-top: 1px ${COLORS.FOOTER_BORDER_COLOR} solid;
    padding: 20px 0 15px;
    margin-top: 78px;
  }
`;

export const DefFooterSpan = styled.span`
  font-size: var(--qr-global-font-size-small);
  color: var(--qr-global-color-text-secondary);
`;

export const DefFooterContainer = styled.div`
  ${mediaMin(breakpoints.tabletL)} {
    display: flex;
    align-items: flex-start;
    max-width: calc(100vw - 64px);
    margin: auto;
  }
`;

export const FooterCTAWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-items: center;
  border-radius: 8px;
  margin: 34px auto 0;
  padding: 28px 26px;
  border: 2px dashed var(--qr-global-color-border-dashed-lightgrey);
  border-radius: 8px;
  width: 300px;

  ${mediaMin(breakpoints.mobileS)} {
    width: 335px;
    padding: 28px 56px;
  }
  ${mediaMin(breakpoints.tabletM)} {
    width: auto;
    flex-direction: row;
    justify-content: space-between;
    padding: 30px;
  }

  ${mediaMin(breakpoints.tabletL)} {
    margin-top: 0px;
    margin-bottom: 43px;
    width: 267px;
    flex-direction: column;
    padding: 22px;
  }
`;

export const FooterCTATitle = styled.h2`
  font-style: normal;
  font-weight: var(--qr-global-font-weight-bold);
  font-size: var(--qr-global-font-size-header-medium);
  line-height: 24px;
  text-align: center;
  margin-bottom: 8px;
  color: var(--qr-global-color-text-primary);

  ${mediaMin(breakpoints.tabletM)} {
    margin-bottom: 0;
  }

  ${mediaMin(breakpoints.tabletL)} {
    text-align: left;
    margin-bottom: 8px;
  }
`;

export const LinksLabel = styled.div`
  font-style: normal;
  font-weight: var(--qr-global-font-weight-bold);
  font-size: var(--qr-global-font-size-default);
  line-height: 24px;
  margin-bottom: 12px;
  color: var(--qr-global-color-blue);
`;

export const FooterCTAButton = styled(BaseButton)`
  width: 191px;
  height: 40px;
  color: var(--qr-global-color-white);
  background: var(--qr-global-color-blue);
  border-radius: 6px;
  font-style: normal;
  font-weight: var(--qr-global-font-weight-bold);
  font-size: var(--qr-global-font-size-header-default);
  line-height: 130%;

  &:hover {
    background-color: var(--qr-global-color-blue-hover);
  }

  ${mediaMin(breakpoints.tabletL)} {
    width: 100%;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  flex-flow: column;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-bottom: 34px;

  svg {
    width: 172px;
    height: 32px;
  }

  ${mediaMin(breakpoints.tabletM)} {
    align-items: flex-start;
    margin-bottom: 60px;
  }

  ${mediaMin(breakpoints.tabletL)} {
    margin-bottom: 40px;
  }
`;

export const LinksWrapperDesktop = styled.nav`
  display: flex;

  a {
    text-decoration: none;
  }
`;

export const LinksWrapperDesktopFirst = styled.div`
  display: flex;
  flex-flow: column;
  margin-left: 93px;
  padding: 0;

  li {
    list-style-type: none;
  }
`;

export const LinksWrapperDesktopSecond = styled.div<{ isSingUpPage?: boolean }>`
  display: flex;
  flex-flow: ${({ isSingUpPage }) => (isSingUpPage ? 'row' : 'column')};
  margin-left: ${({ isSingUpPage }) => (isSingUpPage ? '466px' : '167px')};
  width: ${({ isSingUpPage }) => (isSingUpPage ? '466px' : '')};
  height: ${({ isSingUpPage }) => (isSingUpPage ? '70px' : '')};
  align-items: ${({ isSingUpPage }) => (isSingUpPage ? 'center' : '')};
  justify-content: ${({ isSingUpPage }) => (isSingUpPage ? 'space-between;' : '')};
  padding: 0;

  li {
    list-style-type: none;
  }
`;

export const MenuTitle = styled.p`
  text-align: center;
  font-size: 18px;
  margin: 0;
  padding: 0;
  font-weight: 500;
  line-height: 22px;

  ${mediaMin(breakpoints.tabletM)} {
    text-align: left;
  }
`;

export const LinksWrapper = styled.menu`
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 14px 0 0;
  line-height: 30px;
  text-align: center;

  + * {
    margin-top: 34px;
  }

  li {
    list-style-type: none;
  }

  a {
    text-decoration: none;
    position: relative;

    ${mediaMin(breakpoints.laptopS)} {
      &:hover {
        div {
          display: block;
          visibility: visible;
          opacity: 1;
          transition: all 0.5s ease;
        }
      }
    }
  }

  &.social {
    flex-direction: row;
    gap: 10px;
    align-items: center;
    justify-content: center;

    li {
      display: flex;
      width: 25px;
      height: 25px;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background: #d1d4db;
      transition: 0.5s ease all;

      &:hover {
        background: var(--qr-global-color-button-secondary);
        transition: 0.5s ease all;
      }
    }
    ${mediaMin(breakpoints.tabletM)} {
      justify-content: flex-start;
    }
  }

  ${mediaMin(breakpoints.tabletM)} {
    text-align: left;
  }
`;

export const AllRight = styled.div`
  font-family: var(--qr-global-font-family-primary);
  font-style: normal;
  font-weight: var(--qr-global-font-weight-default);
  font-size: calc(var(--qr-global-font-size-default) - 1px);
  line-height: 18px;
  color: var(--qr-global-color-text-secondary);
  margin-top: 15px;

  ${mediaMax(breakpoints.tabletL - 1)} {
    margin-top: 0px;
    width: 100%;
    text-align: center;
    margin-bottom: 0px;
  }
  ${mediaMax(820)} {
    margin-top: 40px;
  }
`;

export const NavigationBlock = styled.div`
  display: flex;
  align-content: center;
  align-items: center;
  column-gap: 65px;
  width: 478px;

  ${mediaMax(breakpoints.laptopM)} {
    width: unset;
  }

  ${mediaMax(breakpoints.tabletXS)} {
    display: grid;
    row-gap: 11px;
    justify-content: center;
    justify-items: center;
    column-gap: unset;
    padding-left: unset;
  }
`;

export const LinkText = styled.span<{ insideAnchor?: boolean }>`
  text-decoration: none;
  font-style: normal;
  font-weight: var(--qr-global-font-weight-default);
  font-size: var(--qr-global-font-size-default);
  line-height: 24px;
  color: var(--qr-global-color-text-secondary);

  ${(props) =>
    props.insideAnchor &&
    css`
      cursor: pointer;
      &:hover {
        color: var(--qr-global-color-button-secondary);
        text-decoration: underline;
      }
    `}

  &.more {
    color: var(--qr-global-color-button-secondary);
    position: relative;

    &::after {
      content: '';
      background-image: url("data:image/svg+xml,%3Csvg width='18' height='8' viewBox='0 0 18 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.0079 3.76811L0.157901 6.61411C0.107832 6.66392 0.0680992 6.72313 0.0409867 6.78834C0.0138742 6.85356 -8.23186e-05 6.92348 -8.23217e-05 6.99411C-8.23248e-05 7.06473 0.0138742 7.13466 0.0409867 7.19987C0.0680992 7.26509 0.107832 7.3243 0.157901 7.37411C0.259483 7.47414 0.396333 7.53021 0.538902 7.53021C0.681471 7.53021 0.818319 7.47414 0.919902 7.37411L4.1519 4.14911C4.24957 4.05127 4.30573 3.91953 4.30871 3.78132C4.31169 3.64311 4.26126 3.50907 4.1679 3.40711L0.922902 0.158109C0.82212 0.0570611 0.685324 0.000187842 0.542609 3.00625e-07C0.399894 -0.000187241 0.262949 0.0563263 0.161901 0.157109C0.0608539 0.257891 0.0039811 0.394686 0.00379369 0.537401C0.00360629 0.680117 0.0601196 0.817061 0.160902 0.918109L3.0079 3.76811Z' fill='%235482DB'/%3E%3Cpath d='M9.64462 3.76811L6.79462 6.61411C6.74455 6.66392 6.70482 6.72313 6.67771 6.78834C6.65059 6.85356 6.63664 6.92348 6.63664 6.99411C6.63664 7.06473 6.65059 7.13466 6.67771 7.19987C6.70482 7.26509 6.74455 7.3243 6.79462 7.37411C6.8962 7.47414 7.03305 7.53021 7.17562 7.53021C7.31819 7.53021 7.45504 7.47414 7.55662 7.37411L10.7886 4.14911C10.8863 4.05127 10.9425 3.91953 10.9454 3.78132C10.9484 3.64311 10.898 3.50907 10.8046 3.40711L7.55962 0.158109C7.45884 0.0570611 7.32204 0.000187842 7.17933 3.00625e-07C7.03661 -0.000187241 6.89967 0.0563263 6.79862 0.157109C6.69757 0.257891 6.6407 0.394686 6.64051 0.537401C6.64033 0.680117 6.69684 0.817061 6.79762 0.918109L9.64462 3.76811Z' fill='%235482DB'/%3E%3Cpath d='M16.0079 3.76811L13.1579 6.61411C13.1078 6.66392 13.0681 6.72313 13.041 6.78834C13.0139 6.85356 12.9999 6.92348 12.9999 6.99411C12.9999 7.06473 13.0139 7.13466 13.041 7.19987C13.0681 7.26509 13.1078 7.3243 13.1579 7.37411C13.2595 7.47414 13.3963 7.53021 13.5389 7.53021C13.6815 7.53021 13.8183 7.47414 13.9199 7.37411L17.1519 4.14911C17.2496 4.05127 17.3057 3.91953 17.3087 3.78132C17.3117 3.64311 17.2613 3.50907 17.1679 3.40711L13.9229 0.158109C13.8221 0.0570611 13.6853 0.000187842 13.5426 3.00625e-07C13.3999 -0.000187241 13.2629 0.0563263 13.1619 0.157109C13.0609 0.257891 13.004 0.394686 13.0038 0.537401C13.0036 0.680117 13.0601 0.817061 13.1609 0.918109L16.0079 3.76811Z' fill='%235482DB'/%3E%3C/svg%3E%0A");
      background-repeat: no-repeat;
      width: 17px;
      height: 8px;
      position: absolute;
      top: 6px;
      margin-left: 8px;
    }
  }

  ${mediaMax(breakpoints.tabletXS)} {
    font-weight: var(--qr-global-font-weight-default);
    font-size: var(--qr-global-font-size-default);
    line-height: 19px;
    color: var(--qr-global-color-text-secondary);
  }
`;

export const LiteFooterContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 20px 0;

  ${mediaMax(breakpoints.tabletL)} {
    flex-direction: column;
    gap: 55px;
    align-items: center;
    padding-top: 58px;
    padding-bottom: 16px;
  }
`;

export const Nav = styled.nav`
  display: grid;
  width: 100%;

  ${mediaMin(breakpoints.tabletM)} {
    grid-template-columns: auto auto;
    gap: 40px;
  }

  ${mediaMin(breakpoints.tabletL)} {
    margin-left: 40px;
  }

  ${mediaMin(breakpoints.laptopS)} {
    margin-left: 80px;
    gap: 60px;
  }
`;

export const FooterColumn = styled.div`
  display: grid;
`;
export const MenuColumnLeft = styled.div``;
export const MenuColumnRight = styled.div`
  margin-top: 34px;

  ${mediaMin(breakpoints.tabletM)} {
    margin-top: 0;
  }
`;
export const Tooltip = styled.div`
  background: var(--qr-global-color-text-primary);
  position: absolute;
  padding: 0 8px;
  border-radius: 6px;
  color: white;
  font-size: 14px;
  text-align: center;
  visibility: hidden;
  opacity: 0;
  left: 50%;
  line-height: 24px;
  transform: translateX(-50%);
  margin-top: 16px;

  &::before {
    content: '';
    position: absolute;
    top: -6px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-bottom: 6px solid var(--qr-global-color-text-primary);
  }
`;

export const LiteFooterBox = styled.menu`
  margin: 0;
  padding: 0;
  display: flex;

  span,
  li {
    list-style-type: none;
    padding: 0 34px;
    border-right: 1px solid var(--qr-global-color-border-lightgrey);
    border-left: 1px solid var(--qr-global-color-border-lightgrey);

    &:first-of-type {
      padding-left: 0;
      border-left: none;
    }
    &:last-of-type {
      padding-right: 0;
      border-right: none;
    }
    ${mediaMax(breakpoints.tabletL)} {
      padding: 0;
      border: none;
    }
  }

  a {
    text-decoration: none;
  }

  ${mediaMax(breakpoints.tabletL)} {
    flex-direction: column;
    gap: 16px;
    align-items: center;
  }
`;

export const LiteFooterCopy = styled.div`
  ${mediaMax(breakpoints.tabletL)} {
    text-align: center;
    span {
      font-size: var(--qr-global-font-size-small);
    }
  }
`;
